import initMultiInputPin from '../modules/multi-input-pin';
import _t from '../modules/translations';

const initialize = () => {
    initMultiInputPin('.eu-panel button[type="submit"]', true);

    const form = document.getElementById('verify_email_form');

    form.addEventListener('submit', (e) => {
        const captchaResponse = document.querySelector('input[name="g-recaptcha-response"]');

        if (!captchaResponse || !captchaResponse.value || captchaResponse.value.trim() === '') {
            e.preventDefault();
            // eslint-disable-next-line no-alert
            alert(_t('Captcha verification in progress, please wait...'));
            return false;
        }
        return true;
    });
};

export default initialize;
